import { action } from 'easy-peasy';
import { ISetIsExpansionPlanAction } from '../types';

const setIsExpansionPlan: ISetIsExpansionPlanAction = action((state, payload) => {
  state.isExpansionPlan = payload;
});

export default setIsExpansionPlan;
